import {Component, ViewEncapsulation} from '@angular/core';

@Component({
    selector: 'authenticated',
    templateUrl: './authenticated.component.html',
    styleUrls: ['./authenticated.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class AuthenticatedComponent {}